import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SpreadsheetSection from './components/SpreadsheetSection';
import HowItWorksSection from './components/HowItWorksSection';
import TopicsSection from './components/TopicsSection';
import TrustSection from './components/TrustSection';
import ArticlesSection from './components/ArticlesSection';
import FinalCtaSection from './components/FinalCtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <SpreadsheetSection />
        <HowItWorksSection />
        <TopicsSection />
        <ArticlesSection />
        <TrustSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}